<template>
  <div
    :id="questionId"
    :name="name"
    class="questionModel"
    @disableInput="disableInput()"
    @enableInput="enableInput()"
  >
    <b-row class="mx-0">
      <b-col cols="12">
        <label class="questionLabelStyle">{{ label }}</label>
        <div v-if="helpText">
          <p class="helpTextStyle"><span v-html="helpText"></span></p>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  export default {
    name: 'SubSection',
    props: ['label', 'name', 'helpText', 'questionId'],
    data() {
      return {};
    },
    computed: {},
    methods: {
      disableInput() {
        document.getElementById(this.questionId).classList.add('hideElement', 'pl-5');
        //  document.getElementById(this.questionId + '_value').setAttribute('hideElement', 'true');
      },
      enableInput() {
        document.getElementById(this.questionId).classList.remove('hideElement');
        // document.getElementById(this.questionId + '_value').removeAttribute('hideElement');
      },
    },
  };
</script>
<style scoped></style>
